class insightsLoader {

    constructor() {
        this.initFilters();
    }

    initFilters() {
        document.addEventListener('DOMContentLoaded', () => {
            let params = new URLSearchParams(window.location.search);

            Array.from(document.querySelectorAll('[data-insights-filters]')).forEach((el) => {
                Array.from(el.querySelectorAll('.filter-list input[type=checkbox]')).forEach((checkbox) => {
                    checkbox.addEventListener('change', function () {
                        let taxonomy = this.dataset.taxonomy;
                        let term = this.dataset.term;
                        let currentFilters = params.get(taxonomy);
                        if (this.checked) {
                            // add to query string
                            if (currentFilters == null) {
                                currentFilters = [];
                            } else {
                                currentFilters = currentFilters.split(',');
                            }
                            currentFilters.push(term);
                            console.log(currentFilters);
                            params.set(taxonomy, currentFilters.join(','));
                        } else {
                            // remove from query string
                            currentFilters = currentFilters.split(',');
                            currentFilters.splice(currentFilters.indexOf(term), 1);
                            console.log(currentFilters);
                            if (currentFilters.length > 0) {
                                params.set(taxonomy, currentFilters.join(','));
                            } else {
                                params.delete(taxonomy);
                            }
                        }
                        let pageRemovalRegex = /\/page\/[0-9]/i;
                        window.location = window.location.pathname.replace(pageRemovalRegex, '') + '?' + params.toString();
                    });

                });
            });
        });
    }
}

window.app.add('insights', new insightsLoader());